var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAskAndWinActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0693 24.8634V20.1558L16.9905 20.302L17.9117 20.1558V24.8634H16.0693Z",
    fill: "#00BFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.67 8.78432C10.67 8.78432 7.48842 7.24384 7.50003 10.2611C7.50003 10.2611 7.46907 12.926 9.26498 15.1112C9.26498 15.1112 10.6661 17.0378 13.0929 17.7723C13.0929 17.7723 12.4194 16.7678 12.0827 16.0032C12.0827 16.0032 9.87652 14.7888 9.08307 12.2851C9.08307 12.2851 7.68195 8.84804 10.6661 10.0699V8.78432H10.67Z",
    fill: "#00BFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9161 18.904C19.9161 18.904 18.5886 20.3021 16.9901 20.3021C15.3916 20.3021 14.064 18.904 14.064 18.904C12.419 17.2999 11.5211 14.5675 11.5211 14.5675C10.3483 11.5952 10.7741 7 10.7741 7H16.9901H23.2023C23.2023 7 23.6318 11.5952 22.4591 14.5675C22.4591 14.5675 21.5611 17.2961 19.9161 18.904ZM17.9332 12.0496L17.081 10.0928L16.2287 12.0496L14.0435 12.2298L15.702 13.6194L15.2037 15.6877L17.081 14.5897L18.9582 15.6877L18.46 13.6194L20.1184 12.2298L17.9332 12.0496Z",
    fill: "#00BFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3302 8.78432C23.3302 8.78432 26.5118 7.24384 26.5002 10.2611C26.5002 10.2611 26.531 12.926 24.7351 15.1112C24.7351 15.1112 23.3341 17.0378 20.9072 17.7723C20.9072 17.7723 21.5807 16.7678 21.9175 16.0032C21.9175 16.0032 24.1236 14.7888 24.9171 12.2851C24.9171 12.2851 26.3182 8.84804 23.3341 10.0699V8.78432H23.3302Z",
    fill: "#00BFFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5203 25.4409H11.4546V27.0001H22.5203V25.4409Z",
    fill: "#00BFFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8863 24.8633H15.0933V25.4405H18.8863V24.8633Z",
    fill: "#00BFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAskAndWinActive);
export default __webpack_public_path__ + "static/media/ask-and-win-active.a3a1b9316ccd779180a4736ebaf0cf3c.svg";
export { ForwardRef as ReactComponent };